import { combineReducers } from 'redux';
import displayHeader from './header';
import topDropdownMenu from './topDropdownMenu';

export default combineReducers({
  displayHeader,
  topDropdownMenu,
});
